import { render, staticRenderFns } from "./UsedFeaturesAndLibraries.vue?vue&type=template&id=44e38788"
import script from "./UsedFeaturesAndLibraries.vue?vue&type=script&lang=js"
export * from "./UsedFeaturesAndLibraries.vue?vue&type=script&lang=js"
import style0 from "./UsedFeaturesAndLibraries.vue?vue&type=style&index=0&id=44e38788&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports